export default (w = window) =>
  decodeURI(w.location.hash.slice(1)).replace(/%26/g, '&');
